import React, { useState } from 'react';
import { useEffect } from 'react';
import { FaCheck } from 'react-icons/fa';
import { toast } from 'react-toastify';
import apiClient from '../../api/apiClient';
import useApi from '../../hooks/useApi';
import Divider from '@mui/material/Divider';
import image from './../../assets/img/Car1.jpeg';
import CampaignPhotos from '../../components/mui/CampaignPhotos';
import { Link, useNavigate } from 'react-router-dom';
import { Box, Pagination, Typography } from '@mui/material';
import { AdminButton, TableMui } from '../../components/mui';
import { UserMap } from '../../components/maps/MapCustom';
export default () => {
   const [open, setOpen] = useState(false);
   const [data, setData] = useState({
      invoice: null,
      upload_photo: null,
   });
   useEffect(()=>{
      document.title = "RollingAdz: Compaign Details" || "Default Title";
    },[])
   const handleChange = (key, value) => {
      setData({ ...data, [key]: value });
   };
   const { request, loading, error } = useApi((formData) =>
      apiClient.post('/photographerJob', formData)
   );

   useEffect(() => {
      const fetch = async () => {
         const response = await apiClient.get('/photographerJob');
         const data = response.data;
         setData(data);
      };
      // fetch();
   }, []);
   const handleSubmit = async (e) => {
      e.preventDefault();
      const formData = new FormData();
      formData.append('invoice', data.invoice);
      formData.append('upload_photo', data.upload_photo);

      const result = await request(formData);
      if (!result.ok) return toast.error('Error');
      toast.success('Campaign Succesfully Created');
   };
   const dataUsers = [
      {
         name: 'Jack',
         email: '10@example.com',
         role: 'Installer',
      },
      {
         name: 'hassan',
         email: '1@example.com',
         role: 'Designer',
      },
      {
         name: 'ali',
         email: '1h@example.com',
         role: 'Agency',
      },

      {
         name: 'Johson',
         email: '1@example.com',
         role: 'Vehicle Owner',
      },
   ];
   return (
      <div>
         <form onSubmit={handleSubmit}>
            <div className="site-content h-100">
               <div className="p-4">
                  <div className="site-content-body">
                     <div className="container-fluid main_bg_color">
                        <div className="row">
                           <div className="col-md-8 px-md-2">
                              <div>
                                 {/* Carousel */}
                                 <div
                                    id="demo"
                                    className="carousel slide"
                                    data-ride="carousel"
                                 >
                                    {/* The slideshow/carousel */}
                                    <div className="carousel-inner test-2">
                                       <div className="carousel-item active">
                                          <div className="row d-md-flex py-1 slider_border_radius">
                                             <div className="col-md-6 px-2">
                                                <div className="slider_img_height">
                                                   <img
                                                      src={require('../../assets/img/jobs_JustDoIt_img.png')}
                                                      className=" img-fluid h-100 w-100"
                                                      alt=""
                                                   />
                                                </div>
                                             </div>
                                             <div className="col-md-6 px-2">
                                                <div
                                                   className=" slider_line_height "
                                                   style={{ color: 'grey' }}
                                                >
                                                   <div className="d-flex message_dot_Posetion">
                                                      <h4 className="mb-3 mt-2 me-3">
                                                         Driver and Vehicle
                                                         Info.
                                                      </h4>
                                                      <div className="posetion">
                                                         <i className="bi bi-chat-left-fill fa-2x my-auto message_color" />
                                                         <i className="bi bi-dot fa-3x dot_posetion" />
                                                      </div>
                                                   </div>
                                                   <p>
                                                      <span className="fw-bold">
                                                         Name:
                                                      </span>
                                                      <span> Ralf Sims</span>
                                                   </p>
                                                   <p>
                                                      <span className="fw-bold">
                                                         Email:
                                                      </span>
                                                      <span>
                                                         ralfsims@gmail.com
                                                      </span>
                                                   </p>
                                                   <p>
                                                      <span className="fw-bold">
                                                         Phone Number:
                                                      </span>
                                                      <span> 123-904-3245</span>
                                                   </p>
                                                   <p>
                                                      <span className="fw-bold">
                                                         Model/Make:
                                                      </span>
                                                      <span>Hino 155</span>
                                                   </p>
                                                   <p>
                                                      <span className="fw-bold">
                                                         Year:
                                                      </span>
                                                      <span>2012</span>
                                                   </p>
                                                   <p>
                                                      <span className="fw-bold">
                                                         License Plate:
                                                      </span>
                                                      <span> GLE623</span>
                                                   </p>
                                                </div>
                                             </div>
                                          </div>
                                       </div>
                                    </div>
                                 </div>
                              </div>
                           </div>
                           <div className="col-md-4 px-md-2 mt-md-0 mt-2">
                              <div
                                 className="bg_more_deatils  p-3"
                                 style={{ color: 'grey' }}
                              >
                                 <span className="bottom_line mb-3">
                                    <h5 className>Job Details</h5>
                                 </span>
                                 <p>
                                    <span className="fw-bold">
                                       Number of vehicles:
                                    </span>
                                    <span> 3 vehicles</span>
                                 </p>
                                 <p>
                                    <span className="fw-bold">Address:</span>
                                    <span>231 Moda Rd., Portland, OR</span>
                                 </p>
                                 <p>
                                    <span className="fw-bold">Shoot Date:</span>
                                    <span>12/14/2022</span>
                                 </p>
                                 <p>
                                    <span className="fw-bold">Shoot Time:</span>
                                    <span>12:00 pm - 5:00 pm</span>
                                 </p>
                                 <Divider sx={{ padding: '2px' }} />
                                 <div>
                                    <p>
                                       <span className="fw-bold">
                                          Install Location:
                                       </span>
                                       <span> 321 James Rd., Los Angeles</span>
                                    </p>
                                    <p>
                                       <span className="fw-bold">
                                          Install Date:
                                       </span>
                                       <span>12/14/2022</span>
                                    </p>
                                    <p>
                                       <span className="fw-bold">
                                          Install Time:
                                       </span>
                                       <span>2:00 pm - 5:00 pm</span>
                                    </p>
                                    <p>
                                       <span className="fw-bold">
                                          Packge traking Number:
                                       </span>
                                       <span className=""> 12345678</span>
                                    </p>
                                 </div>
                                 <button className="btn d-flex mx-auto more_detales_button">
                                    more details...
                                 </button>
                              </div>
                           </div>
                        </div>
                        <div className="row">
                           <div className="col-lg-5 col-md-6 px-md-2 my-2">
                              <div className="test-2">
                                 <div className="bg_Map pt-2 pb-3">
                                    <span className="bottom_line ms-3">
                                       <h5 className>Photoshoot locations</h5>
                                    </span>
                                 </div>
                                 <div style={{ width: '100%', height: 350 }}>
                                    <UserMap />
                                 </div>
                              </div>
                           </div>
                           <div className="col-lg-7 col-md-6">
                              <div className="row">
                                 <div className="col-sm-6 p-2">
                                    <div className="test-2 pt-2 bg-white">
                                       <span className="bottom_line ms-3">
                                          <h5 className>Photo Uploads</h5>
                                       </span>

                                       <div className=" p-3 text-center">
                                          <CampaignPhotos
                                             open={open}
                                             close={() => setOpen(false)}
                                          />
                                          <img
                                             onClick={() => {
                                                setOpen(true);
                                             }}
                                             className=" img-fluid "
                                             src={image}
                                             alt=""
                                          />
                                          <div className="p-2">
                                             <p>1/5 </p>
                                          </div>

                                          {/* <button className="py-1 mt-2 px-3 rounded-pill upload_submit">Submit</button> */}
                                       </div>
                                    </div>
                                 </div>
                                 <div className="col-sm-6 p-2">
                                    <div className="test-2 pt-2 bg-white">
                                       <span className="bottom_line ms-3">
                                          <h5 className>Invoice</h5>
                                       </span>
                                       <form action>
                                          <div className="p-3 text-center">
                                             <div className="text-center mx-lg-4 py-2 img_input_color">
                                                <i className="bi bi-file-earmark-fill" />
                                                <br />
                                                <label htmlFor="invoice">
                                                   Upload Here
                                                </label>
                                                <input
                                                   type="file"
                                                   className="form-control"
                                                   hidden
                                                   name
                                                   id="invoice"
                                                   onChange={(e) =>
                                                      handleChange(
                                                         'invoice',
                                                         e.target.files[0]
                                                      )
                                                   }
                                                />
                                             </div>
                                             <img
                                                className="img-fluid w-25"
                                                src={data.invoice}
                                                alt=""
                                             />
                                             <p className="lh-lg text-primary">
                                                OR
                                             </p>
                                             <div className="mx-lg-4">
                                                <input
                                                   type="url"
                                                   name
                                                   className="form-control img_input_color"
                                                   placeholder="Input invoice URL here..."
                                                   id
                                                />
                                             </div>
                                             {/* <button className="py-1 mt-2 px-3 rounded-pill upload_submit">Submit</button> */}
                                          </div>
                                       </form>
                                    </div>
                                 </div>
                                 <div className="col-sm-6 p-2">
                                    <div className="test-2 bg-white pt-2 h-100">
                                       <span className="bottom_line ms-3">
                                          <h5 className>Photo Guide Sheet</h5>
                                       </span>
                                       <div className="p-3 text-center">
                                          <button className="btn px-lg-4 py-2 img_input_color w-100">
                                             Guide Sheet
                                          </button>
                                       </div>
                                       <p className="text-center mt-4 text-danger">
                                          Report problem with job
                                       </p>
                                    </div>
                                 </div>
                                 <div className="col-sm-6 p-2">
                                    <div className="test-2 pt-2 bg-white">
                                       <span className="bottom_line_note ms-3">
                                          <h5 className>Note:</h5>
                                       </span>
                                       <p className="p-3">
                                          As a photographer, you have the
                                          opportunity to capture and preserve
                                          moments in time, and to create visual
                                          stories that communicate emotions,
                                          ideas, and perspectives. Whether you
                                          specialize in a particular type of
                                          photography or have a diverse
                                          portfolio, your skills and creative
                                          vision can make a significant impact
                                          on those who view your work.
                                       </p>
                                    </div>
                                 </div>
                              </div>
                           </div>
                        </div>
                        {/* <div className="mt-3 d-flex align-items-center">
                          <input
                            checked={"checked"}
                            type="checkbox"
                            id="measure_side"
                            className="chk me-1"
                            onClick={(e) =>
                              handleChange("measure_side", e.target.checked)
                            }
                          />
                          <label
                            htmlFor="measure_side"
                            className="notify-h fs-6 lh-base text-secondary ms-1 fw-normal"
                          >
                            Measure side of vehicle (height and width)
                          </label>
                        </div>
                        <div className="mt-3 d-flex align-items-center">
                          <input
                            checked={""}
                            type="checkbox"
                            id="bleed_side"
                            className="chk me-1"
                            onClick={(e) =>
                              handleChange("bleed_side", e.target.checked)
                            }
                          />
                          <label
                            htmlFor="bleed_side"
                            className="notify-h fs-6 lh-base text-secondary ms-1 fw-normal"
                          >
                            (312 - "truck width")/2 = bleed on sides
                          </label>
                        </div>
                        <div className="mt-3 d-flex align-items-center">
                          <input
                            checked={""}
                            type="checkbox"
                            id="art_work"
                            className="chk me-1"
                            onClick={(e) =>
                              handleChange("art_work", e.target.checked)
                            }
                          />
                          <label
                            htmlFor="art_work"
                            className="notify-h fs-6 lh-base text-secondary ms-1 fw-normal"
                          >
                            center artwork on vehicle
                          </label>
                        </div>
                        <div className="mt-3 d-flex align-items-center">
                          <input
                            checked={"checked"}
                            type="checkbox"
                            id="install_all_side"
                            className="chk me-1"
                            onClick={(e) =>
                              handleChange("install_all_side", e.target.checked)
                            }
                          />
                          <label
                            htmlFor="install_all_side"
                            className="notify-h fs-6 lh-base text-secondary ms-1 fw-normal"
                          >
                            Install all 4 sides
                          </label>
                        </div>
                        <div className="mt-3 d-flex align-items-center">
                          <input
                            
                            type="checkbox"
                            id="rolling_adz_decale"
                            className="chk me-1"
                            onClick={(e) =>
                              handleChange(
                                "rolling_adz_decale",
                                e.target.checked
                              )
                            }
                          />
                          <label
                            htmlFor="rolling_adz_decale"
                            className="notify-h fs-6 lh-base text-secondary ms-1 fw-normal"
                          >
                            Install "Rolling Ads" decals (refer to guide sheet)
                          </label>
                        </div> */}
                        {/* <div className="p-3">
                          <h4 >Persons involve in this campaign</h4>
                          <Link to={"/admin/user/1"}>
                          <div className="d-flex gap-2 align-items-center ">
          <h4>Ralf Sims</h4>
          <p className="mb-0">Role: photographer</p>
        </div></Link>
        <Link to={"/admin/user/1"}>
                          <div className="d-flex gap-2 align-items-center ">
          <h4> Sims</h4>
          <p className="mb-0">Role: Advertiser</p>
        </div></Link>
        <Link to={"/admin/user/1"}>
                          <div className="d-flex gap-2 align-items-center ">
          <h4>Ralf </h4>
          <p className="mb-0">Role: photographer</p>
        </div></Link>
        
                        </div> */}

                        <Typography
                           className="p-3"
                           variant="h5"
                           sx={{ marginBottom: '10px' }}
                        >
                           Users
                        </Typography>
                        <Box>
                           <TableMui
                              styleTableTh={{
                                 fontWeight: 'bold',
                                 whiteSpace: 'nowrap',
                              }}
                              //   loading={loading}
                              th={{
                                 name: 'Name',
                                 email: 'Email',
                                 role: 'Role',
                              }}
                              td={dataUsers}
                              customBtn={(row) => <CustomBtn row={row} />}
                           />
                        </Box>
                        <div className="d-flex justify-content-end me-5"></div>
                        {/* <div className="select-applies d-flex flex-column align-items-center justify-content-center">
                  <button
                    type="submit"
                    className="btn_bgnone save-changes blue-clr p-3 fs-4 border-0"
                  >
                    <span className="pe-2">Save Changes</span>
                    <FaCheck />
                  </button>
                </div> */}
                     </div>
                  </div>
               </div>
            </div>
         </form>
      </div>
   );
};
function CustomBtn({ item }) {
   const navigate = useNavigate();

   const blogDetail = (item) => {
      navigate('/admin/user/' + 1);
   };

   return <AdminButton onClick={() => blogDetail(item)} name="Detail" />;
}
